<template>
  <div>
    <v-combobox
      ref="combobox"
      solo
      class="thin-border mb-2"
      v-model="val"
      :loading="fetching"
      :label="label"
      :items="items"
      :filter="filter"
      @change="clearInput()"
      @update:searchInput="showAddbtn()"
      dense
      small-chips
      clearable
      persistent-hint
      hint="Selecciona da lista ou escreve em texto livre"
      :item-value="itemValue"
      :item-text="itemText"
    >
      <v-btn
        @click="addItem"
        small
        color="primary"
        v-if="isAddBtnVisible"
        slot="append-outer"
        icon
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-combobox>
  </div>
</template>

<script>
export default {
  props: {
    fetching: { type: Boolean, default: false },
    items: { type: Array, default: () => [] },
    label: { type: String, default: '' },
    value: { type: [String, Object] },
    itemsKeyName: { type: String, default: 'value' },
    itemValue: { type: String, default: '' },
    itemText: { type: String, default: '' }
  },
  data() {
    return {
      fetchingUserList: true,
      isAddBtnVisible: false
    }
  },
  computed: {
    val: {
      get() {
        const itemObj = this.items.find(
          item => item[this.itemValue] === this.value
        )
        return itemObj || this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    filter(item, queryText, itemText) {
      const normalizedDescription = itemText
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      const normalizedQueryText = queryText
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      return (
        item.value.toLowerCase().includes(normalizedQueryText) ||
        normalizedDescription.includes(normalizedQueryText)
      )
    },
    addItem() {
      if (this.isMultiple) {
        const currentVal = this.$refs.combobox.initialValue
        const newVal = this.$refs.combobox.internalSearch
        this.$refs.combobox.setValue([...currentVal, newVal])
      } else {
        this.addSingleItem()
      }
    },
    addSingleItem() {
      const newVal = this.$refs.combobox.internalSearch
      this.$refs.combobox.setValue(newVal)
    },
    showAddbtn() {
      if (
        this.$refs.combobox &&
        this.$refs.combobox.internalSearch &&
        this.$refs.combobox.internalSearch.length > 2
      ) {
        this.isAddBtnVisible = true
      } else {
        this.isAddBtnVisible = false
      }
    },
    clearInput() {
      if (this.isMultiple) {
        setTimeout(() => {
          this.$refs.combobox.internalSearch = ''
        }, 500)
      }
    }
  }
}
</script>
